var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnowledgeGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 23") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.1587939,0.186374168 L6.23314312,1.00250516 C6.33688656,1.01919069 6.44261156,1.01942107 6.54642673,1.0031878 L11.8075356,0.180524073 C12.3531899,0.0952017655 12.8646974,0.468374528 12.9500197,1.01402877 C12.9580114,1.0651373 12.9620253,1.11678889 12.9620253,1.16851847 L12.9620253,9.70154007 C12.9620253,10.1828351 12.6191756,10.5958546 12.1461053,10.6844513 L6.70286116,11.7038639 C6.58191191,11.7265153 6.4578207,11.7266492 6.33682284,11.7042589 L0.818041628,10.6830221 C0.343981574,10.5952985 7.25175048e-16,10.1818242 0,9.6997159 L0,1.17368592 C-5.34943678e-16,0.621401171 0.44771525,0.17368592 1,0.17368592 C1.05318449,0.17368592 1.10628423,0.177928795 1.1587939,0.186374168 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-325.000000, -6274.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-23",
    transform: "translate(325.000000, 6274.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-35",
    transform: "translate(2.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.44619364,4.85916066 L11.4313395,5.32768704 C11.5326697,5.34359108 11.6358436,5.34381073 11.7372406,5.32833828 L14.8491533,4.8534828 C15.3951183,4.77017246 15.9052468,5.14522821 15.9885572,5.69119326 C15.9961748,5.74111444 16,5.79154093 16,5.84203997 L16,10.7492277 C16,11.2321701 15.6548558,11.6461097 15.1797822,11.7329342 L11.8503931,12.3414133 C11.73222,12.3630106 11.6111224,12.3631383 11.492904,12.3417903 L8.11343239,11.7315217 C7.63739391,11.6455582 7.29113924,11.2311762 7.29113924,10.7474383 L7.29113924,5.8470666 C7.29113924,5.29478185 7.73885449,4.8470666 8.29113924,4.8470666 C8.34305963,4.8470666 8.39490118,4.85111018 8.44619364,4.85916066 Z",
    id: "\\u77E9\\u5F62",
    fill: "#1C89B3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u77E9\\u5F62",
    fill: "#12CBDA",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.240506, 3.240506)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fillRule: "evenodd",
    cx: 1.87608261,
    cy: 3.24050633,
    r: 1.87608261
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fillRule: "evenodd",
    cx: 5.37241839,
    cy: 1.10859427,
    r: 1.10859427
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fillRule: "evenodd",
    cx: 5.37241839,
    cy: 4.51965356,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.90063367,0.70814421 C5.12179613,0.542790719 5.43512922,0.588032829 5.60048271,0.809195291 C5.74746359,1.00578415 5.72804794,1.27519917 5.56658931,1.4487752 L5.49943163,1.50904433 L3.003,3.375 L5.50041463,4.03631418 C5.73769549,4.09915006 5.88976278,4.322392 5.87097802,4.55870675 L5.85575777,4.6476498 C5.79292189,4.88493067 5.56967995,5.03699796 5.33336521,5.01821319 L5.24442215,5.00299295 L1.74808637,4.07710559 C1.37275725,3.97771224 1.25792561,3.51675021 1.51156213,3.25093946 L1.57668363,3.19331614 L4.90063367,0.70814421 Z",
    id: "\\u8DEF\\u5F84-43",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeGraph);
export default __webpack_public_path__ + "static/media/knowledge_graph.031051a8197e09c8091ca5ae362cc8a5.svg";
export { ForwardRef as ReactComponent };